__turbopack_context__.v({
  "Path": "index-module-scss-module__E0dCbG__Path",
  "Spinner": "index-module-scss-module__E0dCbG__Spinner",
  "dash": "index-module-scss-module__E0dCbG__dash",
  "rotator": "index-module-scss-module__E0dCbG__rotator",
});
